"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dematerialize = void 0;
var Notification_1 = require("../Notification");
var lift_1 = require("../util/lift");
var OperatorSubscriber_1 = require("./OperatorSubscriber");
function dematerialize() {
  return lift_1.operate(function (source, subscriber) {
    source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (notification) {
      return Notification_1.observeNotification(notification, subscriber);
    }));
  });
}
exports.dematerialize = dematerialize;
